import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ms-expansion-panel',
    templateUrl: './expansion-panel.html',
    imports: [NgClass],
})
export class ExpansionPanelComponent {
    @Input() collapsed = false;
    @Output() panelToggle = new EventEmitter<void>();

    toggle(): void {
        this.collapsed = !this.collapsed;
        this.panelToggle.emit();
    }
}
